<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="dataRight">
        <div class="stateTable">
          <el-scrollbar>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane name="first"
                ><span slot="label"
                  ><i class="iconfont icon-benyue"></i>{{$t('common.timeOfTheMonth')}}</span
                >
                <div v-if="'first' === activeName">
                  <MonthTime ref="monthTime"></MonthTime>
                </div>
              </el-tab-pane>
              <el-tab-pane name="second"
                ><span slot="label"
                  ><i class="iconfont icon-shijianzhouqi"></i>{{$t('common.cumulativeTime')}}</span
                >
                <div v-if="'second' === activeName">
                  <DataPage ref="dataRef"></DataPage>
                </div>
              </el-tab-pane>
              <el-tab-pane name="third"
                ><span slot="label"
                  ><i class="iconfont icon-riqi"></i>{{$t('common.choseTime')}}</span
                >
                <ChangeTime ref="changeTime"></ChangeTime>
              </el-tab-pane>
            </el-tabs>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaintenanceAnalysis from "./MaintenanceAnalysis.js";
export default MaintenanceAnalysis;
</script>

<style lang='less' scoped>
@import "../../../assets/styles/Style.less";
</style>
